// Privacy-API client.
//
// Posts to ${api.base_url}${api.create_user_privacy_request_path} with the
// caller's Cognito *access token* in the `Authorization` header (no `Bearer`
// prefix needed; AVP authorizer accepts either form).
//
// Payload schema, per InputModelSchema in the API contract:
//   { requestType: "deleteAccount"|"deleteData"|"sendData",
//     channel:     "email"|"app" }
import { CONFIG } from "../generated/config.js";
import { currentAccessToken } from "./auth.js";

export async function submitPrivacyRequest(requestType) {
  if (!["deleteAccount", "deleteData", "sendData"].includes(requestType)) {
    throw new Error(`Invalid requestType: ${requestType}`);
  }
  const token = currentAccessToken();
  if (!token) throw new Error("Not logged in");

  const url =
    CONFIG.api.base_url.replace(/\/+$/, "") +
    CONFIG.api.create_user_privacy_request_path;
  const resp = await fetch(url, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: JSON.stringify({ requestType, channel: "email" }),
  });

  if (!resp.ok) {
    let detail;
    try {
      detail = await resp.text();
    } catch {
      detail = "";
    }
    // ⚠️  `message` MUST stay generic — the caller in main.js shouldn't have
    // to know that err.message could contain backend internals. Detail goes
    // on .status / .body for programmatic / console.error inspection.
    const err = new Error(`Privacy API request failed (${resp.status})`);
    err.status = resp.status;
    err.statusText = resp.statusText;
    err.body = detail;
    throw err;
  }

  // 200/202 with empty body is the success contract today; tolerate either.
  try {
    return await resp.json();
  } catch {
    return {};
  }
}
